import { Cell, Row } from "@tanstack/react-table";
import { useEffect, useState } from "react";

import { useTableContext } from "../../context";
import { useCellFocusReturn } from "./use-cell-edit";

interface SelectOption {
  value: string | boolean;
  label: string;
}

export default function CellSelect<T>({
  row,
  cell,
  options,
}: {
  row: Row<T>;
  cell: Cell<T, unknown>;
  options: SelectOption[];
}) {
  const { table, t } = useTableContext();

  const updateData = table?.options?.meta?.updateData;
  const isUpdating = table?.options?.meta?.isUpdating ?? false;
  const columnId = cell.column?.id;
  const cellValue = cell.getValue() as string | undefined;

  const [value, setValue] = useState(cellValue || "");

  useEffect(() => {
    setValue(cellValue || "");
  }, [cellValue]);

  const { controlProps } = useCellFocusReturn<T, HTMLSelectElement>({
    row,
    cell,
  });

  return (
    <select
      {...controlProps}
      value={value}
      onChange={(event) => {
        const newValue = event.target.value;
        setValue(newValue);
        updateData?.(row, columnId, newValue);
      }}
      disabled={isUpdating}
      className="w-full h-target px-2 py-1 border border-default rounded-sm focus:outline-none focus:ring-1 focus:ring-focus focus:border-focus disabled:bg-surface disabled:cursor-not-allowed"
    >
      <option value="" disabled>
        {t("selectAnOption")}
      </option>
      {options.map((option) => (
        <option key={option.value.toString()} value={option.value.toString()}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
